import React from 'react';
import Layout from '../../components/UI/Layout/Layout';
import TitlesList from '../../components/Entity/Titles/TitlesList';

const TitlesPage = () => {
  return (
    <Layout>
      <TitlesList />
    </Layout>
  );
};

export default TitlesPage;
